import Vue from 'vue'
import VueI18n from 'vue-i18n'
import xss from 'xss'
import { getLanguageLong } from '@didi/gettext'
import { i18nInit, i18nGet } from '@didi/i18n-plugin'
import emergency from './emergency'

import zhCN from './zh-CN'
import enUS from './en-US'
import ptBR from './pt-BR'
import jaJP from './ja-JP'
import esMX from './es-MX'
import esCO from './es-CO'
import es419 from './es-419'
import esMXFallback from './fallback/fallback-MX'
import es419Fallback from './fallback/fallback-419'


Object.assign(zhCN, emergency['zh-CN'])
Object.assign(enUS, emergency['en-US'])
Object.assign(ptBR, emergency['pt-BR'])
Object.assign(jaJP, emergency['ja-JP'])
Object.assign(esMX, emergency['es-MX'])
Object.assign(esCO, emergency['es-CO'])
Object.assign(es419, emergency['es-419'])

i18nInit(require('./i18n-info'))
Vue.use(VueI18n)
 
Object.assign(esMX, esMXFallback)
Object.assign(es419, es419Fallback)

class CustomFormatter {
  interpolate (message, values) {
    let str = xss(message);
    // 变量替换
    str = str.replace(/\{\{([^{}]+)\}\}/g, function(numString, i) {
      return values[i];
    });
    // 样式自定义
    if (values) {
      const { styleOptions: {customClass = "highlight", tag = "span" } = {} } = values
      const template = '<' + tag + ' class=' + customClass + '>$1</' + tag + '>';
      const regExpTemplate = /\{([^{}]+)\}/g;
      // 替换高亮
      str = str.split(regExpTemplate).map(function(match, index) {
        // 在替换值之间交替处理
        return index % 2 ? template.replace('$1', match) : match;
      }).join('')

    }
    return str
  }
}
export default new VueI18n({
  locale: getLanguageLong(), // 设置地区
  formatter: new CustomFormatter(), // 适配I18N翻译平台占位符 {{variable}}
  messages: {
    'en-US': i18nGet(enUS, 'en-us'),
    'zh-CN': i18nGet(zhCN, 'zh-cn'),
    'pt-BR': i18nGet(ptBR, 'pt-br'),
    'es-MX': i18nGet(esMX, 'es-mx'),
    'es-CO': i18nGet(esCO, 'es-co'),
    'ja-JP': i18nGet(jaJP, 'ja-jp'),
    'es-419': i18nGet(es419, 'es-419'),
  },
})
